import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-apollo';

import {
  ALBUM_PHOTO_GROUPS_SORT,
  SORT_DIRECTION,
} from '../../../../../../../../../../../constants/sort';
import { albumPhotosFilterUpdate } from '../../../../../../../../../redux/albumPhotosFilter/albumPhotosFilterActions';
import { AlbumPhotosWithPhotoGroups } from '../../../../../../../../../../../graphql/queries/albums';
import { ALBUM_PHOTO_FILTERS } from '../../../../../../../../../../../constants/albums';
import { createLoadMoreMethod } from '../../../../../../../../../../../util/apollo';

const useFilteredUngroupedPhotos = ({ albumId }) => {
  const dispatch = useDispatch();
  const { albumPhotoFilter, sortByShootTime, uploaderIds } = useSelector(
    ({ pro }) => pro.albumPhotosFilter,
  );
  const onAlbumPhotosFilterUpdate = useCallback(
    (...args) => dispatch(albumPhotosFilterUpdate(...args)),
    [dispatch],
  );

  useEffect(() => {
    onAlbumPhotosFilterUpdate({ albumPhotoFilter: ALBUM_PHOTO_FILTERS.ALL });
  }, []);

  const { data: { album, loading, fetchMore } = {} } = useQuery(
    AlbumPhotosWithPhotoGroups,
    {
      variables: {
        id: albumId,
        ignore_watermark: true,
        limit: 100,
        offset: 0,
        album_photo_filter: albumPhotoFilter || ALBUM_PHOTO_FILTERS.ALL,
        uploader_ids: uploaderIds || [],
        sort: {
          field: ALBUM_PHOTO_GROUPS_SORT.CREATED_AT,
          direction: SORT_DIRECTION.ASC,
        },
        sort_by_shoot_time: sortByShootTime || false,
      },
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
      ssr: false,
    },
  );

  const loadMore = createLoadMoreMethod({
    source: album,
    recordsPath: 'photos_ungrouped',
    fetchMore,
  });

  return {
    album,
    loading,
    loadMore,
    photos: album?.photos_ungrouped?.records ?? [],
    photosTotal: album?.photos_ungrouped?.total ?? 0,
    onAlbumPhotosFilterUpdate,
    albumPhotoFilter,
    uploaderIds,
    sortByShootTime,
  };
};

export default useFilteredUngroupedPhotos;
